import { AI_CONNECTIONS_ENABLED } from '@/config/aiConnections';
import { mutationReviewNavCount } from '@/stores/mutationReviewNavCount';

export default [
  {
    title: 'AI Integration',
    icon: { icon: 'mdi:robot-outline' },
    badgeContent: 'Preview',
    badgeClass: 'bg-primary',
    children: [
      {
        title: 'AI Actions',
        action: 'read',
        subject: 'Management',
        to: 'ppc-ai-actions',
        icon: { icon: 'mdi:lightning-bolt' },
        get badgeContent() {
          const count = mutationReviewNavCount.value;
          return count > 0 ? String(count) : undefined;
        },
        badgeClass: 'bg-primary',
      },
      {
        title: 'AI Preferences',
        to: 'settings-ai-preferences',
        action: 'read',
        subject: 'Management',
        isNeedBusinessProfile: true,
        icon: { icon: 'mdi-creation-outline' },
      },
      {
        title: 'Connections & Permissions',
        to: 'settings-ai-connections',
        action: 'read',
        subject: AI_CONNECTIONS_ENABLED ? 'User' : 'Management',
        isNeedBusinessProfile: true,
        icon: { icon: 'lucide:link' },
      },
      {
        title: 'Webhooks',
        to: 'settings-webhooks',
        envOnly: 'development',
        action: 'read',
        subject: 'Management',
        isNeedBusinessProfile: true,
        icon: { icon: 'mdi:webhook' },
      },
      ...(import.meta.env.VITE_ENABLE_MCP_EVENTS === 'true' ? [{
        title: 'MCP Events',
        to: 'settings-mcp-events',
        action: 'read',
        subject: 'Management',
        isNeedBusinessProfile: true,
        icon: { icon: 'mdi:bell-outline' },
      }] : []),
      {
        title: 'How-to',
        to: 'ai-assistant-how-to',
        action: 'read',
        subject: 'Management',
        icon: { icon: 'mdi-book-open-page-variant-outline' },
      },
    ],
  },
];
